import { memo, useCallback, useContext, useEffect, useRef } from "react"

import { isIOS } from "@be-miniapp/shared/utils/device"
import { AnimationRouterContext } from "@be-miniapp/ui/components/animated-context"

import { useInitLanguage } from "@/hooks/use-init-language"

const TouchInitialization = memo(() => {
  useInitLanguage()

  const initialX = useRef<number | null>(null)
  const initialY = useRef<number | null>(null)

  var startTouch = useCallback(function startTouch(e: any) {
    initialX.current = e.touches[0].clientX
    initialY.current = e.touches[0].clientY
  }, [])

  const setAnim = useContext(AnimationRouterContext)?.setAnimate

  var moveTouch = useCallback(
    function moveTouch(e: any) {
      if (initialX.current === null) {
        return
      }

      if (initialY.current === null) {
        return
      }

      var currentX = e.touches[0].clientX
      var currentY = e.touches[0].clientY
      var diffX = initialX.current - currentX
      var diffY = initialY.current - currentY

      if (
        initialX.current <= 20 &&
        Math.abs(diffX) > Math.abs(diffY) &&
        diffX <= 0
      ) {
        setAnim?.({ animate: false, direction: "backward" })
        e?.preventDefault()
      }

      initialX.current = null
      initialY.current = null
    },
    [setAnim]
  )

  useEffect(() => {
    var ios = isIOS()

    if (ios) {
      document.addEventListener("touchstart", startTouch, {
        passive: false,
      })
      document.addEventListener("touchmove", moveTouch, {
        passive: false,
      })
    }

    return () => {
      if (ios) {
        document.removeEventListener("touchstart", startTouch)
        document.removeEventListener("touchmove", moveTouch)
      }
    }
  }, [moveTouch, startTouch])

  return null
})

TouchInitialization.displayName = "TouchInitialization"

export { TouchInitialization }
